import request from '@/utils/request'

export function getConsultList(data) {
  return request.post('/consultation/list', data)
}

export function modifyConsult(data) {
  return request.post('/consultation/modify', data)
}

export function addConsult(data) {
  return request.post('/consultation/add', data)
}

export function addConsultDetail(data) {
  return request.post('/consultation/add-detail', data)
}

export function modifyConsultDetail(data) {
  return request.post('/consultation/modify-detail', data)
}

export function deleteConsultDetail(data) {
  return request.post('/consultation/delete-detail', data)
}

export function getChannelList(data) {
  return request.post('/consultation/channel-list', data)
}

export function getResourceList(data) {
  return request.post('/offline/list', data)
}

export function getSysDictionariesList(data) {
  return request.post('/sys-dictionaries/list', data)
}

export function modifyOffline(data) {
  return request.post('/offline/modify', data)
}

export function addOffline(data) {
  return request.post('offline/add', data)
}




// WEBPACK FOOTER //
// ./src/api/consult.js